import React from "react";
import { PageWrapper } from "../../components/modules/wrapper";
import WillDisplay from "./WillDisplay";

export const WillDisplayContainer = () => {
  return (
    <PageWrapper>
      <WillDisplay />
    </PageWrapper>
  );
};
